import { cn } from "@/components/util/cn"
import FullScreenBackgroundGradient from "@/components/backgrounds/FullScreenBackgroundGradient"
import { KeyboardAvoidingView, ScrollView, View } from "react-native"
import BackflipLogo from "@/assets/logo/backflip-logo.svg"
import useDeviceAttributes from "@/hooks/useDeviceAttributes"
import { useSafeAreaInsets } from "react-native-safe-area-context"
import { type ReactNode, useState } from "react"

export const BFLogoScreen = ({ children }: { children?: ReactNode }) => {
  const [height, setHeight] = useState(0)
  const { isWeb, isIos } = useDeviceAttributes()
  const insets = useSafeAreaInsets()

  return (
    <KeyboardAvoidingView
      className={cn("flex flex-col flex-1 bg-midnight-blue")}
      behavior={!isIos ? "height" : "padding"}
    >
      <FullScreenBackgroundGradient />
      <ScrollView
        testID="onboarding-scroll-view"
        className="flex flex-col h-full"
        onLayout={(event) => {
          setHeight(event.nativeEvent.layout.height)
        }}
        automaticallyAdjustKeyboardInsets={true}
      >
        <View
          className={cn(
            "relative p-8 flex flex-col w-full",
            isWeb && "max-w-md mx-auto"
          )}
          style={{
            minHeight: height,
            // paddingBottom: insets.bottom + 32, we got tabs on bottom..
            paddingTop: insets.top + (isWeb ? 32 : 42),
          }}
        >
          <View
            className="flex flex-row justify-start w-full "
            testID="backflip-logo-view"
          >
            <BackflipLogo width={125} height={43} />
          </View>
          {children}
        </View>
      </ScrollView>
    </KeyboardAvoidingView>
  )
}
